import React from 'react';

export const disclaimerMessages = {
  value: 'Disclaimer',
  list: [
    {
      value: (
        <>
          To the fullest extent permitted by applicable law, Glints and its
          associated companies, officers, directors, employees or agents shall
          not be liable in any event for damage of any kind suffered by any
          users whatsoever directly or indirectly arising from or relating to
          such users’ use of or inability to use the site and its contents,
          including without limitation any errors or omissions in such contents,
          or any deletion, incorrect or delayed transmission or loss of any
          contents or materials uploaded or transmitted through the site.
        </>
      ),
    },
  ],
};
